import React from 'react';
import { ContentWrapper, Header, PopupContent, PopupImage, PopupTextBlock } from '../Popups.styles';
import { createPopup, closePopup } from '../../../services/popupService';
import { ConfirmButton, DismissButton } from '../Popups.styles';
import { oneBtnPopupCreator, ESCALATE_POPUP_CONFIG } from '../ConfirmPopup/helper';
import { connect } from 'react-redux';
import {
  getOutboundEscalationObject,
  extractSelectedTicketFromState,
  getBusinessBlacklistWordsInfoOfSelectedTicket,
  getBusinessBlacklistRegexesInfoOfSelectedTicket,
} from '../../../extractFromState';
import { setOutboundEscalationObject } from '../../../actions/index';
import { isLiveChat } from 'util/chat';
import { getMatchingBlacklistedPhrases } from '../../../util/util';
import {
  ReasonDropdownSelect,
  ValidationErrorMessage,
  CustomMessageTextArea,
  StyledSubheading,
} from './EscalateToSpecialistsPopup.styles';
import { handleError } from 'services/ErrorService/ErrorService';

export const reasonOptions = [
  'Customer is very upset',
  'I initially tagged this ticket incorrectly',
  'Escalate per partner rules',
  'I cannot find the answer',
  'Unable to locate order details',
  'Simplr Specialist suggested escalation',
];

export default class EscalateToSpecialistsPopupComponent extends React.Component {
  _isMounted = false;

  state = {
    reasonSelection: '',
    sendButtonDisabled: false,
  };

  // disable send button if default message has brackets
  componentDidMount() {
    this._isMounted = true;
    if (this.props.outboundEscalationObject) {
      this.checkMessageBeforeSending(this.props.outboundEscalationObject.outboundEscalationMessage);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getValidationError() {
    if (!this.props.escalationReason && !this.state.reasonSelection) {
      return 'Please select a reason for escalation';
    }

    return null;
  }

  checkMessageBeforeSending(message) {
    try {
      const blacklistWords = this.props.blacklistWords;
      const blacklistRegexes = this.props.blacklistRegexes;
      const match = getMatchingBlacklistedPhrases(message, blacklistWords, blacklistRegexes);
      if (this._isMounted) {
        this.setState({ sendButtonDisabled: !!match });
      }
    } catch (error) {
      handleError({ error });
      if (this._isMounted) {
        this.setState({ sendButtonDisabled: false });
      }
    }
  }

  render() {
    return (
      <div>
        <ContentWrapper>
          <PopupContent>
            <Header>Are you sure you want to escalate?</Header>
            <PopupTextBlock>If you can't resolve the ticket on your own, escalate to a specialist</PopupTextBlock>
            {!this.props.escalationReason && (
              <>
                <ReasonDropdownSelect
                  value={this.state.reasonSelection}
                  onChange={({ target: { value } }) => this.setState({ reasonSelection: value })}
                >
                  <option>Select a reason</option>
                  {reasonOptions.map((reason) => (
                    <option key={reason}>{reason}</option>
                  ))}
                </ReasonDropdownSelect>
                {this.state.hasSubmitted && this.getValidationError() && (
                  <ValidationErrorMessage error={true}>
                    <PopupImage src="/images/error-esclamation.svg" alt="error-icon" />
                    {this.getValidationError()}
                  </ValidationErrorMessage>
                )}
                {this.props.isSelectedTicketLiveChat && (
                  <>
                    <StyledSubheading>Send message to the customer (Optional)</StyledSubheading>
                    <CustomMessageTextArea
                      type="text"
                      placeholder="Please explain the escalation reason to the customer."
                      value={
                        this.props.outboundEscalationObject &&
                        this.props.outboundEscalationObject.outboundEscalationMessage
                      }
                      onChange={({ target: { value } }) => {
                        this.checkMessageBeforeSending(value);
                        this.props.setOutboundEscalationObject({
                          ...this.props.outboundEscalationObject,
                          outboundEscalationMessage: value,
                        });
                        this.setState({ hasSubmitted: false });
                      }}
                    />
                  </>
                )}
              </>
            )}
          </PopupContent>
        </ContentWrapper>
        <DismissButton
          onClick={() => {
            closePopup();
          }}
        >
          Dismiss
        </DismissButton>
        <ConfirmButton
          disabled={this.state.sendButtonDisabled}
          onClick={() => {
            this.setState({ hasSubmitted: true });
            if (!this.getValidationError()) {
              closePopup();
              this.props
                .onEscalate({
                  reasonSelection: this.props.escalationReason || this.state.reasonSelection,
                })
                .then(() => oneBtnPopupCreator(ESCALATE_POPUP_CONFIG.escalateConfirmConfig))
                .catch((error) => handleError({ error }));
            }
          }}
        >
          Escalate Now
        </ConfirmButton>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  outboundEscalationObject: getOutboundEscalationObject(state),
  isSelectedTicketLiveChat:
    !!extractSelectedTicketFromState(state) && isLiveChat(extractSelectedTicketFromState(state).communicationType),
  blacklistWords: getBusinessBlacklistWordsInfoOfSelectedTicket(state),
  blacklistRegexes: getBusinessBlacklistRegexesInfoOfSelectedTicket(state),
});

const mapDispatchToProps = (dispatch) => ({
  setOutboundEscalationObject(message) {
    dispatch(setOutboundEscalationObject(message));
  },
});

const EscalateToSpecialistsPopupContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(EscalateToSpecialistsPopupComponent);

export const openEscalationToSpecialistsPopup = (escalationReason, onEscalate) =>
  createPopup({
    type: 'EscalateToSpecialistsPopupComponent',
    title: null,
    content: <EscalateToSpecialistsPopupContainer onEscalate={onEscalate} escalationReason={escalationReason} />,
    noOverlay: false,
    closeOnOutsideClick: false,
  });
